import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { forgotPasswordVerify } from "../../actions/auth/forgotPasswordVerify";
import { Form, Input, Button, Card, message } from "antd";
import {
  calculatePasswordScore,
  PasswordScoreClasses,
  PasswordScoreLabels
} from "../helpers/calculatePasswordScore";
import Swal from "sweetalert2";

function ForgotPasswordVerify(props) {
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [passwordScore, setPasswordScore] = useState(0);
  const [passwordScoreAgain, setPasswordScoreAgain] = useState(0);
  const [lastCode, setLastCode] = useState(null); // Son kullanılan kodu saklar

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setPasswordScore(calculatePasswordScore(password));
    setPasswordScoreAgain(calculatePasswordScore(passwordAgain));
  }, [password, passwordAgain]);

  const completeForgotPassword = async () => {
    if (password !== passwordAgain) {
      message.error("Şifreler eşleşmiyor. Lütfen kontrol ediniz.");
      return;
    }

    if (code === lastCode) {
      message.warning("Aynı doğrulama kodunu tekrar kullanamazsınız!");
      return;
    }

    try {
      const response = await dispatch(forgotPasswordVerify(code, password)).unwrap();
      message.success("Şifre başarıyla değiştirildi!");
    } catch (error) {
      console.error("Şifre değiştirme hatası:", error);

      // 1️⃣ API'den özel bir hata mesajı gelmişse onu al
      let errorMessage = "Şifre değiştirme işlemi başarısız oldu!";

      if (error && error.data) {
        errorMessage = error.data.responseMessage || errorMessage;
      }

      // 2️⃣ Konsolda büyük hata loglarını göstermemek için sadece hata mesajını yaz
      console.warn("Şifre değiştirme başarısız:", errorMessage);

      // 3️⃣ Kullanıcıya sadece uygun mesajı göster
      message.warning(errorMessage);
    }
  };




  useEffect(() => {
    if (props.forgotPasswordVerify.done) {
      message.success("Şifre başarıyla değiştirildi!");
      navigate("/login?status=changepassword");
    } else if (
      props.forgotPasswordVerify.error &&
      props.forgotPasswordVerify.error.response?.status === 429
    ) {
      Swal.fire({
        icon: "error",
        title: "Erişim Kısıtlandı",
        text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
        footer: `
          <div>
            <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
            <br>
            <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
            <br>
            <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
          </div>
        `
      });
    }
  }, [props.forgotPasswordVerify, navigate]);

  const handleSubmit = () => {
    if (password !== passwordAgain) {
      message.error("Şifreler eşleşmiyor. Lütfen kontrol ediniz.");
      return;
    }

    // Eğer girilen kod, son kullanılan kodla aynıysa uyarı göster ve işlem yapma
    if (code === lastCode) {
      message.warning("Aynı doğrulama kodunu tekrar kullanamazsınız!");
      return;
    }

    // Kod farklıysa istek at ve son kullanılan kodu güncelle
    setLastCode(code);
    dispatch(forgotPasswordVerify(code, password));
  };

  const isButtonDisabled =
    code.length !== 6 || // Kod 6 karakter olmalı
    password !== passwordAgain || // Şifreler eşleşmeli
    passwordScore < 3; // Şifre gücü orta veya daha düşük olmamalı

  return (
    <div className="flex justify-center items-center max-h-screen md:h-screen bg-gray-100">
      <Card className="shadow-xl p-4 w-full max-w-full md:max-w-[600px] h-screen md:h-[450px]">
        <div className="text-center">
          <div className="flex justify-between">
            <div>
              <h2 className="block text-lg font-bold text-gray-800 mb-5">
                Yeni Şifre Belirle
              </h2>
            </div>
            <div className="w-14">
              <img
                src="https://www.onedose.io/wp-content/uploads/2020/09/onedose_black.png"
                alt="logo"
              />
            </div>
          </div>
        </div>
        <Form layout="vertical" onFinish={completeForgotPassword}>
          <Form.Item
            label="Kod"
            name="code"
            rules={[
              { required: true, message: "Kod zorunludur!" },
              { len: 6, message: "Kod 6 karakter uzunluğunda olmalıdır!" }
            ]}
          >
            <Input
              placeholder="Doğrulama kodu"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Şifre"
            name="password"
            rules={[{ required: true, message: "Şifre zorunludur!" }]}
            extra={
              <div className={`mt-2 ${PasswordScoreClasses[passwordScore]}`}>
                {PasswordScoreLabels[passwordScore]}
              </div>
            }
          >
            <Input.Password
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Şifre Tekrar"
            name="passwordAgain"
            rules={[{ required: true, message: "Şifre tekrar zorunludur!" }]}
            extra={
              <div
                className={`mt-2 ${PasswordScoreClasses[passwordScoreAgain]}`}
              >
                {PasswordScoreLabels[passwordScoreAgain]}
              </div>
            }
          >
            <Input.Password
              placeholder="Şifre tekrar"
              value={passwordAgain}
              onChange={(e) => setPasswordAgain(e.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="w-full"
              disabled={isButtonDisabled}
              loading={props.forgotPasswordVerify.spinner}
            >
              {props.forgotPasswordVerify.spinner
                ? "İşlem devam ediyor..."
                : "Devam Et"}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => ({
  forgotPasswordVerify: state.forgotPasswordVerify
});

export default connect(mapStateToProps)(ForgotPasswordVerify);
